export const fbConfig = {
  apiKey: "AIzaSyApCiWj28c46N9IqBftrEeHkWmN3hZM3lM",
  authDomain: "obs-barometer.firebase~app.com",
  databaseURL: "https://obs-barometer.firebaseio.com",
  projectId: "obs-barometer",
  storageBucket: "obs-barometer.appspot.com",
  messagingSenderId: "132406131811"
};

export const appConfig = {
  id: fbConfig.projectId,
  appName: "BRMTR",
  email: "pieter.vanwelden@stad.gent",
  logo: "BAROMETER",
  home: "/start",
  background: "background-ocg.jpg",
  functions_url: "https://us-central1-obs-barometer.cloudfunctions.net",
  share_prefix: "barometerocg",
  register_as_individual: false,
  register_as_group: true,
  hide_show_results_after_submit: true,
  color1: "#007db3",
  color2: "#53bc76",
  languages: [
    { key: "nl_BE", label: "Nederlands", labelNL: "Nederlands", default: true },
    { key: "fr_BE", label: "Français", labelNL: "Frans" },
    { key: "tr_TR", label: "Türk", labelNL: "Turks" },
    {
      key: "sh_SH",
      label: "Srpskohrvatski jezik",
      labelNL: "Servo-Kroatisch"
    },
    { key: "sk_SK", label: "Slovenský", labelNL: "Slowaaks" },
    { key: "pl_PL", label: "Polski", labelNL: "Pools" },
    { key: "en_GB", label: "English", labelNL: "Engels" },
    { key: "bg_BG", label: "български", labelNL: "Bulgaars" },
    { key: "ar_SA", label: "العربية", labelNL: "Arabisch" },
    { key: "ru_RU", label: "русский", labelNL: "Russisch" },
    { key: "es_ES", label: "Español", labelNL: "Spaans" },
    { key: "sq_AL", label: "Shqiptar", labelNL: "Albanees" },
    { key: "fa_IR", label: "فارسی", labelNL: "Farsi" }
  ],
  field_types: [
    {
      label: "Thema / Groep vragen",
      value: "fieldset",
      roles: ["creator", "admin", "mentor"]
    },
    { label: "Titel", value: "legend", roles: ["creator", "admin"] },
    {
      label: "Open vraag",
      value: "text",
      roles: ["creator", "admin", "mentor"]
    },
    {
      label: "Keuzelijst",
      value: "list",
      roles: ["creator", "admin", "mentor"]
    },
    {
      label: "Ja/Nee",
      value: "boolean",
      roles: ["creator", "admin", "mentor"]
    },
    {
      label: "Schaal",
      value: "scale_custom",
      roles: ["creator", "admin", "mentor"]
    },
    {
      value: "scale",
      label: "Schaal (Helemaal akkoord <> helemaal niet akkoord)",
      options: [
        {
          label: "Helemaal akkoord",
          symbol: "++",
          value: 20,
          order: 1,
          color: "darkgreen",
          key: "ve"
        },
        {
          label: "Akkoord",
          symbol: "+",
          value: 10,
          order: 2,
          color: "lightgreen",
          key: "e"
        },

        {
          label: "Niet akkoord",
          value: -10,
          color: "crimson",
          key: "o",
          order: 3,
          negative: true,
          symbol: "-"
        },
        {
          label: "Helemaal niet akkoord",
          value: -20,
          color: "black",
          order: 4,
          key: "vo",
          negative: true,
          symbol: "--"
        },
        {
          label: "Weet ik niet",
          value: 0,
          color: "lightgray",
          key: "nvt",
          order: 5
        }
      ],
      roles: ["creator", "admin", "mentor"]
    }
  ]
};
